import { AlertTriangle } from "lucide-react";
import { useState } from "react";

import { Textarea } from "@/components/ui/textarea";

export function selectorLines(text: string): string[] {
	return text
		.split("\n")
		.map((line) => line.trim())
		.filter(Boolean);
}

// The connector refuses exact routes below this port for Android instances:
// the emulator side binds the route's own port, and lower ports are
// privileged. iOS reaches them, so the console warns instead of refusing.
const androidMinRoutePort = 1024;

function iosOnlyRoutes(selectors: string[]): string[] {
	return selectors.filter((selector) => {
		const port = /:(\d+)$/.exec(selector)?.[1];
		return port !== undefined && Number(port) < androidMinRoutePort;
	});
}

// SelectorsInput is the selectors textarea of a tunnel form, submitted as
// "selectors", one per line.
export function SelectorsInput({
	id,
	defaultValue,
	rows,
	placeholder,
	disabled,
}: {
	id: string;
	defaultValue?: string;
	rows: number;
	placeholder?: string;
	disabled?: boolean;
}) {
	const [iosOnly, setIosOnly] = useState(() => iosOnlyRoutes(selectorLines(defaultValue ?? "")));
	return (
		<>
			<Textarea
				id={id}
				name="selectors"
				rows={rows}
				defaultValue={defaultValue}
				placeholder={placeholder}
				className="font-mono text-xs"
				disabled={disabled}
				onChange={(event) => setIosOnly(iosOnlyRoutes(selectorLines(event.target.value)))}
			/>
			<p className="text-xs text-muted-foreground">
				One per line: <code>host:port</code>, or a domain such as <code>*.internal</code>.
			</p>
			{iosOnly.length > 0 && (
				<p className="flex items-center gap-1.5 text-xs text-warning">
					<AlertTriangle aria-hidden className="size-3.5 shrink-0" />
					Android cannot reach ports below 1024: {iosOnly.join(", ")}.
				</p>
			)}
		</>
	);
}
